<template>
  <div v-if="loaded" class="print-main">
    <div class="print-left" :style="{ height: `${this.$util.getViewHeight() - 162}px` }">
      <div id="print-content" class="print-content">
        <!-- title -->
        <div class="title-box">
          <h1 class="title-main">{{ $constant.company_info.company_name }}</h1>
          <div class="m-t-5">联系地址：{{ $constant.company_info.company_address }}</div>
          <div class="m-t-5">联系电话：{{ $constant.company_info.company_phone }}</div>
          <h2 class="title-sub">
            送货单
            <span class="title-number">
              <span>NO.</span>
              <span class="title-red">{{ detailData.form_data.delivery_code }}</span>
            </span>
          </h2>
        </div>

        <!-- form_data -->
        <div class="form-main">
          <div class="form-list" v-for="(itemSt, indexSt) in form_data" :key="indexSt">
            <div class="form-item" v-for="(itemNd, indexNd) in itemSt" :key="indexNd">
              <div class="form-key">{{ itemNd.key }}{{ itemNd.key && '：' }}</div>
              <div class="form-val" v-if="itemNd.val">
                <span v-if="itemNd.val === 'delivery_date' || itemNd.val === 'qi_wang_date'">
                  {{
                    detailData.form_data[itemNd.val]
                      ? detailData.form_data[itemNd.val].slice(0, 10)
                      : '&nbsp;'
                  }}
                </span>
                <span v-else>
                  {{ detailData.form_data[itemNd.val] || '&nbsp;' }}
                </span>
                <span
                  v-if="itemNd.val === 'customer_id' && detailData.form_data.customer_rating"
                  class="c-red"
                  >({{ detailData.form_data.customer_rating }})</span
                >
              </div>
            </div>
          </div>
        </div>

        <!-- tableData -->
        <div class="table-main">
          <PrintTable :data="detailData.goods_list" />
        </div>

        <!-- yao qiu -->
        <div class="table-main">单据备注：{{ detailData.form_data.remark || '&nbsp;' }}</div>

        <!-- 签章 -->
        <div class="gai-zhang-box">
          <div class="gai-zhang-cont">
            <div class="gai-zhang-item">送货单位及经手人(签章):</div>
            <div class="gai-zhang-item">日期:</div>
          </div>
          <div class="gai-zhang-cont">
            <div class="gai-zhang-item">收货单位及经手人(签章):</div>
            <div class="gai-zhang-item">日期:</div>
          </div>
        </div>
      </div>
    </div>
    <div class="print-right">
      <div class="print-do">
        <div>
          <el-button class="print-btn" v-print="printData" type="primary" size="small">
            打印
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    PrintTable: () => import('./print-table')
  },
  data() {
    return {
      loaded: false,
      detailData: {
        form_data: {
          qi_ta_yao_qiu_list: []
        },
        list: []
      },
      printData: {
        id: 'print-content',
        popTitle: '&nbsp;'
      },
      form_data: [
        [
          {
            key: '销售单号',
            val: 'delivery_code'
          },
          {
            key: '客户',
            val: 'customer_id'
          },
          {
            key: '部门',
            val: 'bu_men_name'
          }
        ],
        [
          {
            key: '制单人',
            val: 'saler_name'
          },
          {
            key: '审核人',
            val: 'checker_name'
          },
          {
            key: '发货日期',
            val: 'delivery_date'
          }
        ]
      ]
    }
  },
  computed: {
    id() {
      return this.$route.query.id
    }
  },
  mounted() {
    this.getDetailData()
  },
  methods: {
    // 获取详情数据
    getDetailData() {
      this.loaded = false
      this.$api({
        method: 'get',
        url: '/admin/gcvip/songHuo4/detail',
        params: {
          delivery_id: this.id
        }
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            this.detailData = this.$util.deepCopy(res.data.data)
          }
        })
        .catch(() => {})
        .then(() => {
          this.loaded = true
        })
    }
  }
}
</script>

<style lang="less" scoped>
// print
.print-main {
  display: flex;
  background: #f5f7fa;
  .print-left {
    margin: 10px;
    padding: 20px;
    width: 712px;
    background: #fff;
    overflow-y: auto;
    .scroll-bar();
  }
  .print-right {
    margin: 10px 10px 10px 0;
    padding: 10px;
    width: 200px;
    background: #fff;
    .print-btn {
      width: 100%;
    }
    .print-do {
      margin-bottom: 20px;
      padding: 20px;
      text-align: center;
      font-size: 14px;
      background: #f8f8f8;
    }
  }
}

// content
.print-content {
  font-size: 12px;
  line-height: 1.5;
  font-family: 'Arial,Microsoft YaHei,SimHei,SimSun';
  overflow: hidden;
}

// title
.title-box {
  margin: 10px 0 30px 0;
  text-align: center;
}
.title-main {
  margin: 0;
  font-size: 24px;
}
.title-sub {
  position: relative;
  margin: 20px 0 0 0;
  font-size: 20px;
}
.title-number {
  position: absolute;
  top: 0;
  right: 0;
}
.title-red {
  color: #cf2438;
}

// form
.form-main {
  display: flex;
  margin-top: 20px;
}
.form-list {
  flex: 1;
  display: flex;
  flex-direction: column;
  & ~ .form-list {
    margin-left: 10px;
  }
  .form-item {
    display: flex;
    align-items: center;
    .form-key {
      border-bottom: 1px solid #fff;
    }
    .form-val {
      flex: 1;
      padding: 2px 0;
      border-bottom: 1px solid #000;
    }
  }
}

// table
.table-main {
  margin: 20px 0;
}
.gai-zhang-box {
  display: flex;
  margin-top: 40px;
  padding-top: 20px;
  font-size: 14px;
  border-top: 1px solid #000;
  .gai-zhang-cont {
    text-align: right;
    & ~ .gai-zhang-cont {
      margin-left: 90px;
    }
    .gai-zhang-item {
      & ~ .gai-zhang-item {
        margin-top: 10px;
      }
    }
  }
}
</style>
